var hasSubMenu = document.querySelectorAll(".navigation__item--has-children");
var menuToggle = document.querySelector(".navbar__menu-button ");
var menuWrapper = document.querySelector(".navbar__navigation");
var menuText = document.querySelector(".hamburger__text");

Array.prototype.forEach.call(hasSubMenu, function (el, i) {
  var activatingA = el.querySelector(".navigation__link");
  var btn =
    '<button class="submenu__toggle sr-only"><span><span class="sr-only">show submenu for “' +
    activatingA.text +
    "”</span></span></button>";
  activatingA.setAttribute("aria-haspopup", true);
  activatingA.setAttribute("aria-expanded", false);
  activatingA.setAttribute("aria-label", "Open Submenu");
  activatingA.insertAdjacentHTML("afterend", btn);
  activatingA.addEventListener("click", function (event) {
    event.preventDefault();
    let submenu = el.querySelector(".navbar__navigation--sub-menu");
    submenu.classList.toggle("open");
    if (submenu.classList.contains("open")) {
      activatingA.setAttribute("aria-expanded", true);
      activatingA.setAttribute("aria-label", "Close Submenu");
    } else {
      activatingA.setAttribute("aria-expanded", false);
      activatingA.setAttribute("aria-label", "Open Submenu");
    }
  });
});

document.addEventListener("click", function (event) {
  try {

    if ((menuWrapper.classList.contains('open') && !menuWrapper.contains(event.target)) || menuToggle.contains(event.target)) {
      menuWrapper.classList.toggle("open");
      menuToggle.classList.toggle("is-active");
      menuText.innerText === "MENU" ? (menuText.innerText = "CLOSE") : (menuText.innerText = "MENU");
    }
  }
  catch (e) {

  }
});


const topbarLoginButtons = document.querySelectorAll("[data-login]");
const loginScreen = document.querySelector("#top-bar__log-in-screen");
topbarLoginButtons.forEach((loginButton) => {
  loginButton.addEventListener("click", function () {
    loginButton.classList.toggle("is-active");
    loginScreen.classList.toggle("open");
    window.scrollTo(0, 0);
  });
});

// const loginScreen = document.querySelector("#top-bar__log-in-screen");
// const loginButton = document.querySelector("#top-bar__log-in");
// console.log(loginButton);

// document.addEventListener("click", function (ev) {
//   if (document.body.contains(loginScreen) && document.body.contains(loginButton) ) {
//     if ((loginScreen.classList.contains('open') && !loginScreen.contains(ev.target)) || loginButton.contains(ev.target)) {
//       loginScreen.classList.toggle("open");
//       loginButton.classList.toggle("is-active");
//     }
//   }
// });

const topbarSearchButton = document.querySelector("#top-bar__search");
const searchScreen = document.querySelector("#top-bar__search-screen");
if (topbarSearchButton && searchScreen) {
  topbarSearchButton.addEventListener('click', function () {
    topbarSearchButton.classList.toggle('is-active');
    searchScreen.classList.toggle('open');
    var buttonText = topbarSearchButton.querySelector(".text");
    var icon = topbarSearchButton.querySelector("img");
    buttonText.innerHTML == 'Search' ?
      (buttonText.innerHTML = 'Close') :
      (buttonText.innerHTML = 'Search');
    icon.getAttribute('src') == '/themes/custom/nada/images/icons/search.svg' ?
      icon.setAttribute('src', '/themes/custom/nada/images/icons/close.svg') :
      icon.setAttribute('src', '/themes/custom/nada/images/icons/search.svg');
  });
}
